
import React, { useState } from 'react';
import { Button, Box, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from "react-redux";
import { setState, exportTemplate_DataEdit, ImportExcelEdit} from "./editScenarioNewSlice";

function BreakdownUpload() {
  const [uploadedEditFile, setuploadedEditFile] = useState(null);
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.editScenarioNew);
  const {
    countryID, scenarioName, selectedCustsCGs, selectedCountry,editScID
  } = setupState;
  const handleFileUpload = (event) => {
    const fileObj = event.target.files[0];
    setuploadedEditFile(fileObj);
  };

  const handleDelete = () => {
    setuploadedEditFile(null);
  };
  const DownloadTemplate = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    else if (scenarioName === undefined || scenarioName === null || scenarioName === "") {
      showMessage("Please select a Scenario Name", "info");
      return;
    }
    else if (selectedCustsCGs <= 0) {
      showMessage("Please select a customer", "info");
      return;
    }
    else {
      let customersList = [];
      let customerGroupsList = [];
      for (let i = 0; i < selectedCustsCGs.length; i++) {
        if (selectedCustsCGs[i].type === "C") {
          let obj = {};
          obj['customerID'] = selectedCustsCGs[i].id;
          obj['customer'] = {};
          obj['customer']['customerName'] = selectedCustsCGs[i].name;
          customersList.push(obj);
        }
        else if (selectedCustsCGs[i].type === "CG") {
          let obj = {};
          obj['customerGroupID'] = selectedCustsCGs[i].id;
          obj['customerGroup'] = {};
          obj['customerGroup']['customerGroupName'] = selectedCustsCGs[i].name;
          customerGroupsList.push(obj);
        }
        else if (selectedCustsCGs[i].hasOwnProperty("customerID")){
            let obj ={};
            obj['customerID'] = selectedCustsCGs[i].customerID;
            obj['customer'] = {};
            obj['customer']['customerName']= selectedCustsCGs[i].customerName;
            customersList.push(obj);
        }
        else if (selectedCustsCGs[i].hasOwnProperty("customerGroupID")){
            let obj ={};
            obj['customerGroupID'] = selectedCustsCGs[i].customerGroupID;
            obj['customerGroup'] = {};
            obj['customerGroup']['customerGroupName']= selectedCustsCGs[i].customerGroupName;
            customerGroupsList.push(obj);
        }
      }
      let obj = {
        scenarioId: editScID,
        scenarioName: scenarioName, countryId: countryID,
        countryName: selectedCountry, customerGroup: customerGroupsList,
        customer: customersList
      }
      dispatch(exportTemplate_DataEdit(obj));
    }
  }
  const UploadFile = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    else if (scenarioName === undefined || scenarioName === null || scenarioName === "") {
      showMessage("Please select a Scenario Name", "info");
      return;
    }
    else if (selectedCustsCGs <= 0) {
      showMessage("Please select a customer", "info");
      return;
    }
    else {
      dispatch(setState("scenarioExternalDataSource",[]));
      const formData = new FormData();
      formData.append("file", uploadedEditFile, uploadedEditFile.name);
      let recCnt = selectedCustsCGs.length;
      let obj = {
        scenario: scenarioName,
        recCnt: recCnt,
        formData: formData
      }
      dispatch(ImportExcelEdit(obj));
      setuploadedEditFile(null);
    }
  }
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  return (
    <Box>
      <Box>
        <Grid container spacing={3}>
          <Grid item>
            <Box>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "skyBlue.main",
                  color: "blue.main",
                  textTransform: "none",
                  fontSize: 14,
                  fontWeight: 500,
                  mt: 3,
                  p: 1.5,
                  boxShadow:"none",
                  "&:hover": {
                    bgcolor: "blue.main",
                    color: "white.main",
                  },
                }}
                component="span"
                onClick={DownloadTemplate}
              >
                Download Template
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <input
                type="file"
                accept=".xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
                id="fileInput"
                onclick="fileInput.value = null"
                value=""
              />
              <label htmlFor="fileInput">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "skyBlue.main",
                    color: "blue.main",
                    textTransform: "none",
                    fontSize: 14,
                  fontWeight: 500,
                  boxShadow:"none",
                    mt: 3,
                    p: 1.5,
                    "&:hover": {
                      bgcolor: "blue.main",
                      color: "white.main",
                    },
                  }}
                  component="span"
                >
                  Select File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <Button
                variant="contained"
                disabled={uploadedEditFile==null || uploadedEditFile == undefined}
                sx={{
                  bgcolor: "skyBlue.main",
                  color: "blue.main",
                  fontSize: 14,
                  fontWeight: 500,
                  mt: 3,
                  p: 1.5,
                  boxShadow:"none",
                  
                  "&:hover": {
                    bgcolor: "blue.main",
                    color: "white.main",
                  },
                }}
                component="span"
                onClick={UploadFile}
              >
                Upload
              </Button>
            </Box>
          </Grid>

        </Grid>
      </Box>
      <Grid>
        <Box>
          {uploadedEditFile && (
            <div className="file-display">
              <span>{uploadedEditFile.name}</span>
              <Button variant="outlined" color="secondary" onClick={handleDelete}>
                <DeleteIcon />
              </Button>
            </div>
          )}
        </Box>
      </Grid>
    </Box>
  );
}

export default BreakdownUpload;
